import { FilterNameType, ListingPathType } from "./filter-types";

export const FILTERS_KEY_NAME = "list-filters";

export const FILTERS_PARAM_NAME = "rf";

export const DEFAULT_PAGE_SIZE = 10;

export const defaultPagination = {
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};

export const filterQueryParams: Record<ListingPathType, FilterNameType> = {
  affiliates: "af",
  "card-inventory": "np",
  "card-orders": "pc",
  consumers: "cn",
  "debit-funds": "df",
  "load-funds": "lf",
};
